import moment from 'moment';
import { request } from './Api';
import {
  segregateIncidentsOnStatus,
  getOnGoingMaintenance,
  getPlannedIncidents
} from './incidents';
import { filterComponentsList } from './index';

const ipv4ToLong = (address: string): number => {
  if (!address) return 0;
  const parts = address.split('.');
  if (parts.length !== 4) return 0;
  let total = 0;
  for (let i = 0; i < 4; i++) {
    const part = parseInt(parts[i], 10);
    if (Number.isNaN(part) || part < 0 || part > 255) return 0;
    total = (total << 8) + part;
  }
  return total >>> 0;
};

export function capitalizeFirstLetter(string) {
  if (string) return string.charAt(0).toUpperCase() + string.slice(1);
}

export function isFutureDate(date) {
  if (new Date(date) > new Date()) return true;
  return false;
}

export const sortArrayObjects = (arr, param) => {
  arr.sort((a, b) => a[param] - b[param]);
  return arr;
};

export const findIndex = (arr, param, value) => {
  const index = arr.findIndex((item) => item[param] === value);
  return index;
};

export const checkInRange = (real, ipArr) => {
  const realIp = ipv4ToLong(real);
  let found = false;
  ipArr.forEach((range) => {
    const startRange = ipv4ToLong(range.from);
    const endRange = ipv4ToLong(range.to);
    if (startRange <= realIp && realIp <= endRange) found = true;
  });
  return found;
};

export const getYears = (year) => {
  const yearList: any = [];
  const currentYear = moment().format('YYYY');
  for (let y: any = currentYear; y >= year; y--) {
    yearList.push(y.toString());
  }
  return yearList;
};

export const getFormatMonth = (date) => {
  const monthFormat = 'MMM YYYY';
  return moment(date).format(monthFormat);
};

export const getSelectedComponents = (subscriptions, service) => {
  if (
    subscriptions.data &&
    service.group_id &&
    subscriptions.data.subscribed_groups.indexOf(String(service.group_id)) > -1
  ) {
    return true;
  }
  if (
    subscriptions.data &&
    service.id &&
    subscriptions.data.subscribed_services.indexOf(String(service.id)) > -1
  ) {
    return true;
  }
  return false;
};

export const getChildComponents = (node) => {
  if (node.components) {
    return node.components.reduce(
      (a, b) => [...a, ...(b.components ? b.components : [b])],
      []
    );
  }
  if (node.status) {
    return [node];
  }
  return [];
};

export const loadHomePageData = async (
  accountId,
  // params,
  // isFilterComponents
) => {
  const isFilterComponents=false
  const lastThreeMonths = moment()
    .subtract(90, 'days')
    .startOf('day')
    .utc()
    .format();

  const values = await Promise.all([
    request(`/public-components/?account_id=${accountId}`),
    request(
      `/public-incidents/?account_id=${accountId}&end_time__gte=${lastThreeMonths}&end_time__isempty=true`
    ),
    request(
      `/public-incident-statuses/?account_id=${accountId}&incident__end_time__gte=${lastThreeMonths}&incident__end_time__isempty=true`
    )
  ]);

  const componentsData = values[0].components;
  const incidentsData = values[1].results;
  const incidentsStatusesData = values[2].results;
  // filter components and groups based on query params if applicable
  const filteredComponentsList = filterComponentsList(
    componentsData,
  );
  const componentsList = filteredComponentsList.filteredComponentsList;
  const componentGroups = filteredComponentsList.filteredComponentGroups;
  const components = filteredComponentsList.filteredComponents;

  // // filter incidents and groups based on query params if applicable
  let incidents = [];
  // if (isFilterComponents) {
  //   if (components.length > 0) {
  //     const componentIds = [];
  //     components.forEach((component) => {
  //       componentIds.push(component.id);
  //     });

  //     incidentsData.forEach((incident) => {
  //       const isIncidentComponentPresent = incident.affected_components.find(
  //         (component) =>
  //           componentIds.indexOf(parseInt(component.component)) > -1
  //       );
  //       if (isIncidentComponentPresent) {
  //         incidents.push(incident);
  //       }
  //     });
  //   }
  // } else {
    incidents = incidentsData;
 // }
  
  const onGoingMaintenance = getOnGoingMaintenance(
    incidents,
    incidentsStatusesData
  );
  const { pastIncidents, liveIncidents } = segregateIncidentsOnStatus(
    incidents,
    incidentsStatusesData
  );
  const plannedIncidents = getPlannedIncidents(
    incidents,
    incidentsStatusesData
  );
  return {
    componentsList,
    componentGroups,
    components,
    incidents,
    onGoingMaintenance,
    pastIncidents,
    liveIncidents,
    plannedIncidents
  };

};
